import { render, staticRenderFns } from "./NewFeatureInfo.vue?vue&type=template&id=43a7b5b2&"
import script from "./NewFeatureInfo.vue?vue&type=script&lang=js&"
export * from "./NewFeatureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
installComponents(component, {VBottomSheet,VBtn,VIcon,VSheet})
